// This file is auto-generated during the build process
export const BUILD_VERSION = "20260602-3";
export const BUILD_DATE = "2026-06-02T12:57:35.246Z";
